// Localização: ./src/api/aiApi.js
// Funções de API para o Assistente de IA

import api from './api';

/**
 * Envia uma mensagem ao assistente e recebe resposta
 * @param {string} message - Mensagem do usuário
 * @param {string} sessionId - ID da sessão (opcional)
 * @returns {Promise} Resposta do assistente
 */
export const sendChatMessage = async (message, sessionId = null) => {
    return api.post('/ai/chat', {
        message,
        sessionId
    });
};

/**
 * Lista histórico de conversas
 * @param {object} params - { limit, offset }
 * @returns {Promise} Lista de conversas
 */
export const getConversations = async (params = {}) => {
    return api.get('/ai/conversations', { params });
};

/**
 * Busca uma conversa específica por ID
 * @param {number} conversationId - ID da conversa
 * @returns {Promise} Dados da conversa
 */
export const getConversationById = async (conversationId) => {
    return api.get(`/ai/conversations/${conversationId}`);
};

/**
 * Busca todas as mensagens de uma sessão específica
 * @param {string} sessionId - ID da sessão
 * @returns {Promise} Todas as conversas da sessão
 */
export const getConversationsBySession = async (sessionId) => {
    return api.get(`/ai/conversations/session/${sessionId}`);
};

/**
 * Deleta uma conversa
 * @param {number} conversationId - ID da conversa
 * @returns {Promise} Resultado da deleção
 */
export const deleteConversation = async (conversationId) => {
    return api.delete(`/ai/conversations/${conversationId}`);
};

/**
 * Deleta toda uma sessão
 * @param {string} sessionId - ID da sessão
 * @returns {Promise} Resultado da deleção
 */
export const deleteSession = async (sessionId) => {
    return api.delete(`/ai/conversations/session/${sessionId}`);
};

/**
 * Confirma e executa uma ação sugerida
 * @param {object} data - { sessionId, actionId, confirmed, additionalData }
 * @returns {Promise} Resultado da confirmação
 */
export const confirmAction = async (data) => {
    return api.post('/ai/confirm-action', data);
};

